"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CompatibilityFactory_1 = require("./CompatibilityFactory");
var UnitFactory_1 = require("./UnitFactory");
var units_1 = require("./units");
var Converter = /** @class */ (function () {
    function Converter(value, sg) {
        var _this = this;
        this.val = 0;
        this.origin = null;
        this.destination = null;
        this.from = function (from) {
            if (typeof from !== 'string') {
                _this.origin = from;
            }
            else {
                _this.origin = _this.getUnit(from);
            }
            return _this;
        };
        this.to = function (to) {
            if (!_this.origin) {
                throw new Error('.to must be called after .from');
            }
            if (typeof to !== 'string') {
                _this.destination = to;
                return _this.origin
                    .GetMeasure(_this.val, _this.sg)
                    .CreateAs(_this.destination);
            }
            _this.destination = _this.getUnit(to);
            if (_this.origin.AbbreviatedDisplay === _this.destination.AbbreviatedDisplay) {
                return _this.origin.GetMeasure(_this.val, _this.sg);
            }
            return _this.origin.GetMeasure(_this.val, _this.sg).CreateAs(_this.destination);
        };
        this.getUnit = function (abbr) {
            return UnitFactory_1.UnitFactory.GetUnitByName(abbr);
        };
        this.possibilities = function (measure) {
            if (!_this.origin && !measure) {
                return CompatibilityFactory_1.CompatibilityFactory.GetAllUnitAliases();
            }
            if (_this.origin) {
                return CompatibilityFactory_1.CompatibilityFactory.GetCompatibleUnits(_this.origin.GetMeasure(_this.val || 0, _this.sg));
            }
            return CompatibilityFactory_1.CompatibilityFactory.GetUnitAliases(measure);
        };
        this.measures = function () {
            return Object.keys(units_1.unitsByMeasure).filter(function (measure) { return Object.keys(units_1.unitsByMeasure[measure]).length > 0; });
        };
        if (value)
            this.val = value;
        if (sg)
            this.sg = sg;
    }
    return Converter;
}());
exports.convert = function (val, sg) {
    return new Converter(val, sg);
};
exports.convertValue = function (val, sg) {
    return new Converter(val, sg);
};
